import Icon from '../components/Icon.vue'

Icon.register({
  stream: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M16 128c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-416zM496 208c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h416zM432 384c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-416c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/stream.js
// module id = 1957
// module chunks = 0